export default "__VITE_ASSET__CHnvEeBW__"